<template>
  <div class="invite-by-social-container">
    <label v-html="$t('referral.social.share')"></label>
    <div class="invite-by-social-inner">
      <facebook-button @click="shareToFacebook" class="social-btn"></facebook-button>
      <twitter-button @click="shareToTwitter" class="social-btn twi"></twitter-button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import FacebookButton from '@/components/common/social/FacebookButton.vue';
import TwitterButton from '@/components/common/social/TwitterButton.vue';

export default {
  components: {
    FacebookButton,
    TwitterButton,
  },
  computed: {
    ...mapGetters(['referralLink']),
  },
  methods: {
    shareToFacebook() {
      window.FB.init({
        appId: '885791448462931',
        autoLogAppEvents: true,
        xfbml: true,
        version: 'v8.0',
      });

      window.FB.ui({
        method: 'share',
        href: this.referralLink,
      });
    },
    shareToTwitter() {
      window.open(
        `https://twitter.com/intent/tweet?url=${encodeURIComponent(
          this.referralLink,
        )}`,
      );
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/metrics.scss';

span {
  margin: $tiny;
}

.invite-by-social-container {
  flex: 1;
  display: flex;
  align-items: baseline;
  justify-content: space-between;
}

.invite-by-social-inner {
  flex: 1;
  display: flex;
  margin-top: $tiny;
}

.social-btn {
  flex: 1;
}

label {
  flex: 1;
}

.ant-btn {
  margin: 0;
}

.twi {
  margin-left: $tiny;
}
</style>
